import { Select, Spin, Typography } from 'antd'
import React, { useMemo, useState } from 'react'
import useDebounceValue from 'src/exShared/hooks/useDebounceValue'
import { useQueryLabelMasterSearch } from 'src/features/labelCheck/api/useQueryLabelMasterSearch'
import { useGetLabelMasterById } from 'src/features/labelCheck/hooks/useGetLabelMasterById'
import styled from 'styled-components'

const { Text } = Typography
const { Option } = Select

const LabelMasterSelect = styled(Select)`
  width: 100%;
`

const FormRow = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`

const FormLabel = styled.div`
  margin-bottom: 10px;
  width: 100%;
`

type Props = {
  value?: string
  disabled?: boolean
  onChangeLabelMaster: (id: string) => void
}

export const LabelMasterAutocomplete: React.FC<Props> = ({
  value,
  disabled = false,
  onChangeLabelMaster,
}) => {
  const [searchText, setSearchText] = useState<string>('')
  const debouncedKeyword = useDebounceValue(searchText, 300)

  const { data: searchResults = [], isFetching } = useQueryLabelMasterSearch({
    keyword: debouncedKeyword,
  })

  const selectedMaster = useGetLabelMasterById(value)

  // 検索結果に選択済みマスタが含まれていない場合、先頭に追加して表示を保証
  const options = useMemo(() => {
    if (!selectedMaster) return searchResults
    const existsInResults = searchResults.some(r => r.id === selectedMaster.id)
    if (existsInResults) return searchResults
    return [selectedMaster, ...searchResults]
  }, [searchResults, selectedMaster])

  const handleSearch = (input: string) => {
    setSearchText(input)
  }

  const onSelectMaster = (selectedValue: unknown) => {
    if (typeof selectedValue === 'string') {
      onChangeLabelMaster(selectedValue)
      setSearchText('')
    }
  }

  // 入力したkeywordで、候補になるラベルマスタが見つからなかった時に表示するUI
  const notFoundContent = useMemo(() => {
    if (isFetching) return <Spin size="small" />
    if (debouncedKeyword) return '該当なし'
    // 未入力時はデフォルトの「データがありません」を非表示にする
    return null
  }, [isFetching, debouncedKeyword])

  return (
    <FormRow>
      <FormLabel>
        <Text strong>ラベルマスタ名</Text>
      </FormLabel>
      <div>
        <LabelMasterSelect
          showSearch
          filterOption={false}
          onSearch={handleSearch}
          value={value}
          disabled={disabled}
          onChange={onSelectMaster}
          notFoundContent={notFoundContent}
        >
          {options.map(({ id, name, code }) => (
            <Option key={id} value={id}>
              {name}
              {code !== '' && `(${code})`}
            </Option>
          ))}
        </LabelMasterSelect>
      </div>
    </FormRow>
  )
}
